import { cn } from "@/lib/utils";

export const LevelBadge = ({ level, className }) => {
  if (!level) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 border border-gold/40 text-gold px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider",
        className
      )}
      data-testid="level-badge"
    >
      Lv{level.level} · {level.title}
    </span>
  );
};

export const Avatar = ({ src, name, size = 40, className }) => {
  const initials = (name || "?")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return src ? (
    <img
      src={src}
      alt={name}
      style={{ width: size, height: size }}
      className={cn("object-cover warm-img border border-border shrink-0", className)}
    />
  ) : (
    <div
      style={{ width: size, height: size }}
      className={cn(
        "flex items-center justify-center bg-secondary text-secondary-foreground font-mono text-xs border border-border shrink-0",
        className
      )}
    >
      {initials}
    </div>
  );
};

export const ProBadge = ({ founding, className }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider",
      founding ? "bg-gold text-accent-foreground" : "bg-cobalt text-white",
      className
    )}
    data-testid={founding ? "founding-badge" : "pro-badge"}
    title={founding ? "Founding member" : "Ikigora Pro"}
  >
    {founding ? "★ Founding" : "Pro"}
  </span>
);

export const timeAgo = (iso) => {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};
